var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M100,68c0,13.2-10.8,24-24,24H45.1c0.6-1.9,0.9-3.9,0.9-6s-0.3-4.1-0.9-6H76c6.6,0,12-5.4,12-12s-5.4-12-12-12 H24C10.8,56,0,45.2,0,32S10.8,8,24,8h28.8c-0.5,1.9-0.8,3.9-0.8,6s0.3,4.1,0.8,6H24c-6.6,0-12,5.4-12,12s5.4,12,12,12h52 C89.2,44,100,54.8,100,68z M74,8c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S77.3,8,74,8 M74,0c7.7,0,14,6.3,14,14s-6.3,14-14,14 s-14-6.3-14-14S66.3,0,74,0L74,0z M26,86C26,86,26,86,26,86L26,86 M26,74c6.6,0,12,5.4,12,12s-5.4,12-12,12s-12-5.4-12-12 S19.4,74,26,74L26,74z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon48);
export default __webpack_public_path__ + "static/media/motion_icon-48.ac6f9bed.svg";
export { ForwardRef as ReactComponent };